// -> IPortfolioDataManager.GetDataQualityAsync (DataQualityController). A-26's panel.
import { http } from "./http";
import type { DataQualityReport, DataQualitySeverity } from "./generated/contracts";

export interface DataQualityParams {
  readonly minimumSeverity: DataQualitySeverity;
  readonly entityTypes?: readonly string[];
  readonly codes?: readonly string[];
  readonly owner?: string;
  // D-303: sent only when true - mirrors ListProjectsParams.hideCompleted (portfolioData.ts).
  readonly hideCompleted?: boolean;
}

export const dataQualityApi = {
  get: (params: DataQualityParams) => http.get<DataQualityReport>("/api/data-quality", { query: { ...params } }),
};
